import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect } from 'react';
import * as PropTypes from 'prop-types';
import { Constants } from '../utils/constants';
import { SpzaInstrumentService } from '../services/telemetry/spza/spzaInstrument';
import { getWindow } from '../services/window';
import { addClassToElement, removeClassFromElements } from '../utils/appUtils';
import { logger } from '@src/logger';
import heroBanner from '@shared/images/hero-banner-500.png';
import bussAppImg from '@shared/images/buss-app-img.png';
import provideAccess from '@shared/images/provide-access-img.png';
import { Stack, mergeStyles, Text, Image, Link, DefaultButton, ScreenWidthMinXLarge } from '@fluentui/react';
import { NeutralColors, SharedColors } from '@fluentui/theme';
const stackWidth = '50%';
const bannerInnerTextWidth = '20%';
const spacingBetweenStacks = '60px';
const mobileStackWidth = '97%';
const mobileBannerInnerTextWidth = '95%';
const mobileSpacingBetweenStacks = '30px';
const bannerStackStyles = mergeStyles({
    height: 600,
    backgroundColor: '#333',
    backgroundImage: `url(${heroBanner})`,
    backgroundSize: 'contain',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    [`@media (max-width: ${ScreenWidthMinXLarge}px)`]: {
        paddingTop: mobileSpacingBetweenStacks,
        paddingBottom: mobileSpacingBetweenStacks,
        backgroundSize: 'cover',
        height: 400
    }
});
const getStaretedStackStyles = mergeStyles({
    paddingTop: spacingBetweenStacks,
    paddingBottom: spacingBetweenStacks,
    [`@media (max-width: ${ScreenWidthMinXLarge}px)`]: {
        paddingTop: mobileSpacingBetweenStacks,
        paddingBottom: mobileSpacingBetweenStacks
    }
});
const topAppsStackStyles = mergeStyles({
    paddingTop: spacingBetweenStacks,
    paddingBottom: spacingBetweenStacks,
    backgroundColor: NeutralColors.gray20,
    [`@media (max-width: ${ScreenWidthMinXLarge}px)`]: {
        paddingTop: mobileSpacingBetweenStacks,
        paddingBottom: mobileSpacingBetweenStacks
    }
});
const submitToAppsourceStackStyles = mergeStyles({
    backgroundColor: SharedColors.cyanBlue10,
    paddingTop: spacingBetweenStacks,
    paddingBottom: spacingBetweenStacks,
    [`@media (max-width: ${ScreenWidthMinXLarge}px)`]: {
        paddingTop: mobileSpacingBetweenStacks,
        paddingBottom: mobileSpacingBetweenStacks
    }
});
const stackItemStyle = mergeStyles({
    width: stackWidth,
    [`@media (max-width: ${ScreenWidthMinXLarge}px)`]: {
        width: mobileStackWidth
    }
});
const bannerStackItemStyle = mergeStyles({
    width: bannerInnerTextWidth,
    [`@media (max-width: ${ScreenWidthMinXLarge}px)`]: {
        width: mobileBannerInnerTextWidth
    }
});
const stackWithVerticalGap = {
    childrenGap: '1.5%'
};
const whiteText = mergeStyles({
    color: 'white'
});
const PartnersBanner = ()=>{
    return /*#__PURE__*/ _jsx(Stack, {
        tabIndex: -1,
        className: bannerStackStyles,
        horizontalAlign: "center",
        verticalAlign: "center",
        children: /*#__PURE__*/ _jsxs(Stack, {
            tokens: stackWithVerticalGap,
            className: bannerStackItemStyle,
            children: [
                /*#__PURE__*/ _jsx(Stack.Item, {
                    align: "center",
                    children: /*#__PURE__*/ _jsx(Text, {
                        variant: "xLarge",
                        as: "h4",
                        className: whiteText,
                        children: "Build your business faster"
                    })
                }),
                /*#__PURE__*/ _jsx(Stack.Item, {
                    align: "center",
                    children: /*#__PURE__*/ _jsx(Text, {
                        variant: "large",
                        className: whiteText,
                        children: "Reach more customers for your business apps"
                    })
                }),
                /*#__PURE__*/ _jsx(Stack.Item, {
                    children: /*#__PURE__*/ _jsx(Text, {
                        variant: "medium",
                        className: whiteText,
                        children: "AppSource is the premier destination to market and distribute your apps, content packs, and add-ins—all backed by a brand that billions of customers already know and trust. Showcase your apps that work with Dynamics, Office, Power BI, Azure, and more."
                    })
                }),
                /*#__PURE__*/ _jsx(Stack.Item, {
                    align: "center",
                    children: /*#__PURE__*/ _jsx(Link, {
                        href: "#getStarted",
                        children: /*#__PURE__*/ _jsx(DefaultButton, {
                            text: "GET STARTED",
                            tabIndex: -1
                        })
                    })
                })
            ]
        })
    });
};
const PartnersTopApps = ()=>{
    return /*#__PURE__*/ _jsx(Stack, {
        className: topAppsStackStyles,
        children: /*#__PURE__*/ _jsx(Stack.Item, {
            align: "center",
            className: stackItemStyle,
            children: /*#__PURE__*/ _jsxs(Stack, {
                tokens: stackWithVerticalGap,
                children: [
                    /*#__PURE__*/ _jsx(Stack.Item, {
                        children: /*#__PURE__*/ _jsx(Text, {
                            variant: "xxLarge",
                            as: "h2",
                            children: "The premier destination for top apps"
                        })
                    }),
                    /*#__PURE__*/ _jsx(Stack.Item, {
                        align: "center",
                        children: /*#__PURE__*/ _jsx(Text, {
                            variant: "xLarge",
                            as: "h3",
                            children: "Drive more leads"
                        })
                    }),
                    /*#__PURE__*/ _jsx(Stack.Item, {
                        align: "start",
                        children: /*#__PURE__*/ _jsx(Text, {
                            variant: "large",
                            children: "Increase reach, discoverability, and usage of your apps.The Microsoft salesforce and other selling resources help your apps stand out."
                        })
                    }),
                    /*#__PURE__*/ _jsx(Stack.Item, {
                        align: "center",
                        children: /*#__PURE__*/ _jsx(Text, {
                            variant: "xLarge",
                            as: "h3",
                            children: "Focus on your idea, not the infrastructure"
                        })
                    }),
                    /*#__PURE__*/ _jsx(Stack.Item, {
                        align: "start",
                        children: /*#__PURE__*/ _jsx(Text, {
                            variant: "large",
                            children: "Scale from few to many users seamlessly using a cloud platform that grows with you—and infrastructure built to support app consumption."
                        })
                    }),
                    /*#__PURE__*/ _jsx(Stack.Item, {
                        align: "center",
                        children: /*#__PURE__*/ _jsx(Text, {
                            variant: "xLarge",
                            as: "h3",
                            children: "Optimize your apps"
                        })
                    }),
                    /*#__PURE__*/ _jsx(Stack.Item, {
                        align: "start",
                        children: /*#__PURE__*/ _jsx(Text, {
                            variant: "large",
                            children: "Leverage the full Microsoft cloud platform to easily add capabilities and business value to your apps—from innovative, intelligent features to enhanced security and performance."
                        })
                    })
                ]
            })
        })
    });
};
const PartnersGetStarted = ()=>{
    return /*#__PURE__*/ _jsx(Stack, {
        className: getStaretedStackStyles,
        id: "getStarted",
        children: /*#__PURE__*/ _jsx(Stack.Item, {
            align: "center",
            className: stackItemStyle,
            children: /*#__PURE__*/ _jsxs(Stack, {
                tokens: stackWithVerticalGap,
                children: [
                    /*#__PURE__*/ _jsx(Stack.Item, {
                        children: /*#__PURE__*/ _jsx(Text, {
                            variant: "xxLarge",
                            as: "h2",
                            children: "Get started"
                        })
                    }),
                    /*#__PURE__*/ _jsx(Stack.Item, {
                        align: "center",
                        children: /*#__PURE__*/ _jsx(Image, {
                            src: bussAppImg,
                            alt: "Build your business apps"
                        })
                    }),
                    /*#__PURE__*/ _jsx(Stack.Item, {
                        align: "center",
                        children: /*#__PURE__*/ _jsx(Text, {
                            variant: "xLarge",
                            as: "h3",
                            children: "Build your business apps – let business users try it"
                        })
                    }),
                    /*#__PURE__*/ _jsxs(Stack.Item, {
                        align: "center",
                        children: [
                            /*#__PURE__*/ _jsx(Text, {
                                variant: "large",
                                block: true,
                                children: "Develop your line of business app, whether it’s for a specific industry, process, or department like HR,finance, marketing or operations."
                            }),
                            /*#__PURE__*/ _jsx(Text, {
                                variant: "large",
                                block: true,
                                children: "Assure customers that your app is just the app they’re looking for. Let them try it out with a free trial."
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx(Stack.Item, {
                        align: "center",
                        children: /*#__PURE__*/ _jsx(Link, {
                            target: "_blank",
                            rel: "noreferrer",
                            href: "https://aka.ms/azure-app-offer-setup",
                            underline: true,
                            children: "App review guidelines"
                        })
                    }),
                    /*#__PURE__*/ _jsx(Stack.Item, {
                        align: "center",
                        children: /*#__PURE__*/ _jsx(Image, {
                            src: provideAccess,
                            alt: "Grow your business"
                        })
                    }),
                    /*#__PURE__*/ _jsx(Stack.Item, {
                        align: "center",
                        children: /*#__PURE__*/ _jsx(Text, {
                            variant: "xLarge",
                            as: "h3",
                            children: "Grow your business – Promote your Consulting Services Offerings on AppSource"
                        })
                    }),
                    /*#__PURE__*/ _jsxs(Stack.Item, {
                        align: "center",
                        children: [
                            /*#__PURE__*/ _jsx(Text, {
                                variant: "large",
                                block: true,
                                children: "Capitalize on your industry and consulting expertise. Market your fixed price, fixed scope, and fixed duration"
                            }),
                            /*#__PURE__*/ _jsx(Text, {
                                variant: "large",
                                block: true,
                                children: "consulting service offers and connect with new customers."
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx(Stack.Item, {
                        align: "center",
                        children: /*#__PURE__*/ _jsx(Link, {
                            target: "_blank",
                            rel: "noreferrer",
                            href: "https://aka.ms/plan-consulting-service-offer",
                            underline: true,
                            children: "Consulting Services listing guidelines"
                        })
                    })
                ]
            })
        })
    });
};
export const PartnersSumbitToAppsource = ({ locale })=>{
    return /*#__PURE__*/ _jsx(Stack, {
        className: submitToAppsourceStackStyles,
        children: /*#__PURE__*/ _jsx(Stack.Item, {
            align: "center",
            className: stackItemStyle,
            children: /*#__PURE__*/ _jsxs(Stack, {
                tokens: stackWithVerticalGap,
                children: [
                    /*#__PURE__*/ _jsx(Stack.Item, {
                        children: /*#__PURE__*/ _jsx(Text, {
                            variant: "xxLarge",
                            as: "h2",
                            className: whiteText,
                            children: "Submit to AppSource today"
                        })
                    }),
                    /*#__PURE__*/ _jsx(Stack.Item, {
                        children: /*#__PURE__*/ _jsx(Text, {
                            variant: "xLarge",
                            className: whiteText,
                            children: "The AppSource team will validate that your solution meets the review guidelines - then we’ll reach out to you with next steps."
                        })
                    }),
                    /*#__PURE__*/ _jsx(Stack.Item, {
                        align: "center",
                        children: /*#__PURE__*/ _jsx(Link, {
                            href: `https://partner.microsoft.com/${locale}/dashboard/account/v3/enrollment/introduction/commercial-marketplace`,
                            accessibilityEnabled: true,
                            underline: true,
                            children: /*#__PURE__*/ _jsx(DefaultButton, {
                                text: "SUBMIT YOUR OFFER >"
                            })
                        })
                    })
                ]
            })
        })
    });
};
export const Partners = ({ locale }, context)=>{
    useEffect(()=>{
        const perfPayload = {
            page: getWindow().location.href,
            action: Constants.Telemetry.Action.PageLoad,
            actionModifier: Constants.Telemetry.ActionModifier.End
        };
        SpzaInstrumentService.getProvider().probe('logTelemetryInfo', perfPayload);
        logger.info('', {
            action: perfPayload.action,
            actionModifier: perfPayload.actionModifier
        });
        document.getElementsByTagName('title')[0].innerHTML = context.loc('marketing_pageTitle');
        removeClassFromElements('spza-accessibility-selected');
        addClassToElement(Constants.SearchBy.Id, 'uhf_partnerLink', 'spza-accessibility-selected');
    }, [
        context
    ]);
    return /*#__PURE__*/ _jsxs(Stack, {
        role: "main",
        children: [
            /*#__PURE__*/ _jsx(PartnersBanner, {}),
            /*#__PURE__*/ _jsx(PartnersTopApps, {}),
            /*#__PURE__*/ _jsx(PartnersGetStarted, {}),
            /*#__PURE__*/ _jsx(PartnersSumbitToAppsource, {
                locale: locale
            })
        ]
    });
};
Partners.contextTypes = {
    loc: PropTypes.func,
    buildHref: PropTypes.func,
    renderErrorModal: PropTypes.func
};
